/* Restore the normal storefront at the fixed Santiago deadline. No catalog/settings writes. */
(function(){
  'use strict';
  var END=Date.parse('2026-10-11T23:59:00-03:00');
  function isClosed(time){return time>=END;}
  if(typeof document==='undefined'){module.exports={isClosed:isClosed,end:END};return;}
  if(document.documentElement.classList.contains('cf-preview'))return;
  var localQA=/^(localhost|127\.0\.0\.1)$/.test(location.hostname)&&document.documentElement.getAttribute('data-cmomo-preview-now');
  var simulated=localQA?Date.parse(localQA):NaN,loaded=Date.now(),timer=null,done=false;
  function now(){return Number.isFinite(simulated)?simulated+Date.now()-loaded:Date.now();}
  function initializeVideo(){
    var hero=document.querySelector('[data-cyber-normal-home]');if(!hero||hero.hasAttribute('data-video-ready'))return;
    hero.setAttribute('data-video-ready','');
    var video=hero.querySelector('video'),poster=hero.querySelector('.sp4hp-video-poster');if(!video)return;
    var reduced=matchMedia('(prefers-reduced-motion: reduce)');
    function reveal(){if(video.readyState>=2&&!video.paused&&!video.error)poster.hidden=true;}
    video.addEventListener('playing',reveal);video.addEventListener('error',function(){poster.hidden=false;});
    function play(){if(reduced.matches||document.hidden){video.pause();if(reduced.matches)poster.hidden=false;return;}video.muted=true;var result=video.play();if(result)result.catch(function(){poster.hidden=false;});}
    reduced.addEventListener('change',play);document.addEventListener('visibilitychange',play);play();
  }
  function restore(){
    if(done||!isClosed(now()))return false;
    var hero=document.querySelector('.sp4c-chero.sp4c-cneon'),normal=document.getElementById('cfc-normal-home-template');
    // Do not destroy a cached page lacking the fallback. Keep the safe ended state instead.
    if(hero&&(!normal||!normal.content.firstElementChild))return false;
    done=true;document.documentElement.classList.add('cf-normal');
    document.documentElement.classList.remove('cf-campaign','cr-campaign');
    document.documentElement.setAttribute('data-cyber-restored','');
    document.dispatchEvent(new CustomEvent('cyber:closed'));
    document.dispatchEvent(new CustomEvent('cyber:final:activated'));
    if(hero)hero.replaceWith(normal.content.cloneNode(true));
    var collection=document.querySelector('[data-cyber-lab]');
    if(collection){
      var heading=collection.querySelector('.sp4c-coll__title-wrap');
      if(heading){var title=document.createElement('h1');title.className='sp4c-coll__title';title.textContent='Productos SoyMomo';heading.replaceChildren(title);heading.removeAttribute('data-cf-ready');}
      ['data-cyber-lab','data-cf-campaign','data-cmomo-phase','data-lab-ready','data-lab-armed','data-lab-hidden','data-cyber-finale-lab'].forEach(function(attr){collection.removeAttribute(attr);});
      collection.classList.remove('sp4c-coll--cyber');
    }
    document.querySelectorAll('.cmomo-console,.cmomo-sticky,.cf-console,.cyber-lab-momo,.cyber-lab-ring,.cyber-lab-stamp,.cyber-finale-lab-label,.cyber-panda-dock,.cyber-power-trace').forEach(function(el){el.remove();});
    document.querySelectorAll('style[data-cyber-chrome],#cyber-panda-style').forEach(function(el){el.remove();});
    if(location.pathname==='/collections/cyber')document.title='Productos SoyMomo';
    initializeVideo();clearInterval(timer);timer=null;return true;
  }
  window.SoyMomoCyberReturn={restore:restore,isClosed:function(){return isClosed(now());}};
  function boot(){restore();if(!done)timer=setInterval(restore,1000);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('visibilitychange',function(){if(!document.hidden)restore();});
  window.addEventListener('pagehide',function(){clearInterval(timer);timer=null;});
  window.addEventListener('pageshow',function(){restore();if(!done&&!timer)timer=setInterval(restore,1000);});
})();
